'use client';

import { useEffect, useSyncExternalStore } from 'react';

/**
 * Whether the current page is the 404 boundary. `app/not-found.tsx` renders
 * inside AppShell, so the top bar cannot tell from the pathname alone that the
 * route does not exist; without this it humanizes the unknown slug ("Asdasd")
 * as if it were a page title.
 */
let notFound = false;
const listeners = new Set<() => void>();

function setRouteNotFound(next: boolean) {
  if (notFound === next) return;
  notFound = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Marks the page as not found for as long as the calling component is mounted. */
export function useMarkRouteNotFound() {
  useEffect(() => {
    setRouteNotFound(true);
    return () => setRouteNotFound(false);
  }, []);
}

export function useRouteNotFound() {
  return useSyncExternalStore(subscribe, () => notFound, () => false);
}
